// shared/services/with-organ-ws-state.base.ts
import { OrganWsShardStateService } from './organ-ws-shard-state.service';
import { Subscription, combineLatest } from 'rxjs';
import { IWSContext } from '../../../models/workspace/workspace-model';
import { IOrgContext } from '../../../models/organization/organization-model';

export abstract class WithOrganWsStateBase {
    protected currentOrganId: string;
    protected currentWSId: string;

    protected wsContext: IWSContext;
    protected orgContext: IOrgContext;
    private subscription: Subscription;

    constructor(protected orgWsShareState: OrganWsShardStateService) {
        this.subscription = combineLatest([
            this.orgWsShareState.currentOrganId$,
            this.orgWsShareState.currentWSId$,
        ]).subscribe(([organId, wsId]) => {
            this.currentOrganId = organId;
            this.currentWSId = wsId;
            this.wsContext = { organizationId: this.currentOrganId, workspaceId: this.currentWSId };
            this.orgContext = { organizationId: this.currentOrganId };
        });
    }
}
